import { Link } from 'react-router-dom';

/**
 * A round button that shows only an icon.
 *
 * The tag follows what it does: an action is a <button type="button">, a move
 * to another page (`to`) is a link - so a news item's edit pencil can be opened
 * in a new tab. Both carry `ui-button`, which removes what a browser adds to one
 * but not the other (the link underline), so they look the same.
 *
 * `className` is the look (article-edit-button, tag-remove-button, ...);
 * `label` becomes aria-label and, unless `tooltip` is false, the title.
 */
function IconButton({
  icon,
  label,
  className,
  to,
  onClick,
  active = false,
  tooltip = true,
  children,
  ...rest
}) {
  const classes = ['ui-button', className, active ? 'active' : null]
    .filter(Boolean)
    .join(' ');

  const common = {
    className: classes,
    'aria-label': label,
    title: tooltip ? label : undefined,
    ...rest,
  };

  const content = (
    <>
      {icon && <i className={icon} aria-hidden="true" />}
      {children}
    </>
  );

  if (to) {
    return (
      <Link to={to} {...common}>
        {content}
      </Link>
    );
  }

  return (
    <button type="button" onClick={onClick} {...common}>
      {content}
    </button>
  );
}

export default IconButton;
